export let logProps = {
    id: 0,
    service_date: '',
    activity_type: 0,
    supervised_by_staff_id: null,
    service_done_by_contact_id: null,
    notes: '',
    image: ''
}

export let dataProps = {
    id: 0,
    asset_number: '', 
    model_number: '',  
    asset_name: '', 
    description: '',
    issued_to: null,
    caretaker_id: null,
    service_interval: [],
    store_id: null,
    profile_photo: '',
    purchase_date: '',
    warranty_active: true,
    warranty_expiry_date: '',

    log_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/assetMaster/properties.js